export default {
  endpoints: {
    pageLayout: '/pages/layout',
    pageMeta: '/pages/meta',
    schedulerStatus: '/pages/scheduler-status',
    pages: '/pages',
    pageVersions: '/pages/versions',
    competitions: '/competitions',
    competitionsAdmin: '/competitions/admin',
    leagueTable: '/competitions/league-table',
    leagueTables: '/competitions/league-tables',
    leagueTableSeasons: '/competitions/league-tables/seasons',
    leagueOptions: '/competitions/league-options',
    leagueCompetitions: '/competitions/leagues',
    divisionOptions: '/competitions/divisions',
    divisionsWithClubs: '/competitions/divisions/clubs',
    match: '/matches',
    matches: '/matches',
    matchBulkParse: '/matches/bulk-parse',
    matchBulkCreate: '/matches/bulk-create',
    // SC-894 Important Dates. Mirrored in packages/api-endpoints/apiEndpoints.ts — the two
    // maps are maintained separately (see the competitionStages note below), so a path added
    // to one has to be added to the other by hand.
    events: '/events',
    eventsBulkTemplate: '/events/bulk-template',
    eventsBulkParse: '/events/bulk-parse',
    eventsBulkCreate: '/events/bulk-create',
    matchBulkTemplate: '/matches/bulk-template',
    matchesDashboardPostponed: '/matches/dashboard/postponed',
    matchesSeasons: '/matches/seasons',
    matchDates: '/matches/match-dates',
    matchesTodayCompetitions: '/matches/today/competitions',
    articles: '/articles',
    faqs: '/faqs',
    tags: '/tags',
    featuredTags: '/tags/featured',
    tagSuggestions: '/tags/suggestions',
    clubs: '/clubs',
    editableClubs: '/clubs/list-editable',
    clubsDashboardPendingDrafts: '/clubs/drafts/pending',
    bulkClubs: '/clubs/bulk',
    clubStaffExport: '/clubs/staff-export',
    teams: '/teams',
    teamsByEditableClubs: '/teams/by-editable-clubs',
    teamsAllDefault: '/teams/all',
    teamsSearch: '/teams/search',
    assets: '/assets',
    upload: '/assets/upload',
    login: '/auth/login',
    myProfile: '/users/me',
    users: '/users',
    sponsors: '/sponsors',
    mainSponsor: '/sponsors/main',
    navigations: '/navigations',
    // PATCH-only — no GET route exists. Reads go through `navigations` (GET /navigations).
    navigationsFooterComponents: '/navigations/footer-components',
    newsletterSubscribe: '/mails/newsletter-subscribe',
    newsletterConfirm: '/mails/newsletter-confirm',
    jobs: '/jobs',
    socialNetworks: '/social-networks',
    socialShareScreenshot: '/social-share/screenshot',
    socialShareCups: '/social-share/cups',
    socialShareDrafts: '/social-share/drafts',
    socialShareTeams: '/social-share/teams',
    socialShareGoalscorers: '/social-share/goalscorers',
    pinnedItems: '/pinned-items',
    pinnedItemsReorder: '/pinned-items/reorder',
    contacts: '/contacts',
    settings: '/settings',
    matchSettings: '/settings/match',
    articleSettings: '/settings/article',
    themeSettings: '/settings/theme',
    resetTheme: '/settings/theme/reset',
    matchFilters: '/settings/match-filters',
    contactDetailsSettings: '/settings/contact-details',
    contactFormSubjectsSettings: '/settings/contact-form-subjects',
    manageContactFormSubjectsSettings: '/settings/contact-form-subjects/manage',
    divisionsOrder: '/settings/divisions-order',
    clubStaffJobsOrder: '/settings/club-staff-jobs-order',
    tenants: '/tenants',
    tenantMySettings: '/tenants/me/settings',
    tenantConfig: '/tenants/me',
    tenantsFeatureFlags: '/tenants/feature-flags',
    search: '/search',
    contactUs: '/mails/contact-us',
    releaseNotes: '/release-notes',
    releaseNotesLatest: '/release-notes/latest',
    releaseNotesGenerate: '/release-notes/generate',
    releaseNotesGenerationStatus: '/release-notes/generation-status',
    videos: '/videos',
    videosPublished: '/videos/published',
    videoChannels: '/video-channels',
    footballPlayers: '/football-players',
    footballPlayersAutocomplete: '/football-players/autocomplete',
    footballPlayersStatsQuery: '/football-players/stats-query',
    // AI endpoints
    aiStatus: '/ai/status',
    aiGeneratePlayerQuery: '/ai/generate-player-query',
    // Page Templates endpoints
    pageTemplates: '/page-templates',
    playerStatsPresets: '/player-stats-presets',
    // Cronjobs endpoints (proxied through API to dataPuller)
    cronjobs: '/cronjobs',
    cronjobExecutions: '/cronjobs/executions',
    albums: '/albums',
    // Mirrored in packages/api-endpoints/apiEndpoints.ts — the two maps are maintained
    // separately, and only an app build catches a path added to one but not the other.
    engagementCampaigns: '/engagement/campaigns',
    engagementHistory: '/engagement/history',
    engagementHub: '/engagement/hub',
    engagementEntries: '/engagement/entries',
    engagementAdminCampaigns: '/engagement/admin/campaigns',
    // Attendance endpoints
    attendanceStats: '/matches/stats/attendance',
    clubAttendanceList: '/matches/stats/attendance/by-club',
    matchSummary: '/matches/stats/match-summary',
    teamRankings: '/matches/stats/team-rankings',
    goalTiming: '/matches/stats/goal-timing',
    clubStats: '/matches/stats/club',
    // History Logs endpoints
    historyLogs: '/history-logs',
    historyLogsEntityTypes: '/history-logs/entity-types',
    historyLogsUsers: '/history-logs/users',
    switchTenant: '/auth/switch-tenant',
    matchSimulation: '/match-simulation',
    scheduledTasks: '/scheduled-tasks',
    files: '/files',
    filesRecentUploads: '/files/recent-uploads',
    fileAccessLogsRecent: '/file-access-logs/recent',
    leagueTableDiscrepancies: '/league-table-discrepancies',
    reports: '/reports',
    reportsGenerate: '/reports/generate',
    reportsLastMatchDate: '/reports/last-match-date',
    anomalyReportForLeague: '/anomaly-reports/leagues',
    completedMatchCompetitions: '/competitions/completed-match-competitions',
    ppvVideosPublished: '/ppv-videos/published',
    ppvVideosCompetitions: '/ppv-videos/competitions',
    matchMedia: '/matches',
    cacheFlush: '/cache/flush',
    tutorials: '/tutorials',
    // SuperAdmin authoring (SC-1119). `allowlists` is a sibling of the collection root, not an
    // id — the API declares it above `:id` for that reason.
    tutorialsManage: '/tutorials/manage',
    tutorialsManageAllowlists: '/tutorials/manage/allowlists',
    aiGenerateTutorial: '/ai/generate-tutorial',
    // Bug tracker (proxied through API to bugTracker service)
    bugTrackerEvents: '/bug-tracker/events',
    bugTrackerIssues: '/bug-tracker/issues',
    // Web Push goal alerts. Public routes, tenant-scoped via x-tenant-id.
    pushVapidPublicKey: '/push/vapid-public-key',
    pushSubscriptions: '/push/subscriptions',
    pushSubscriptionsRemove: '/push/subscriptions/remove',
    // Invoices (proxied through API to the invoice service — SC-1114)
    invoices: '/invoices',
    invoicePreview: '/invoices/preview',
    invoicePreviewEmail: '/invoices/preview-email',
    // Repeatable invoices (proxied through API to the invoice service — SC-1115)
    repeatableInvoices: '/repeatable-invoices',
    // Expense invoices — the invoices the gatherer files FROM our suppliers, proxied through API
    // to the invoice service (SC-1110 Phase 2b). Distinct from `invoices` above, which are the
    // ones we issue TO tenants.
    expenses: '/expenses',
    // Declared as its own path rather than built as `${expenses}/facets`: the backend has to keep
    // this route above its `:id` catch-all, and naming it here keeps that surface visible.
    expensesFacets: '/expenses/facets',
    // The bulk ZIP (SC-1110 Phase 4). Its own path for the same reason `facets` is: the backend
    // has to keep it above its `:id` catch-all, and naming it here keeps that surface visible.
    expensesDownload: '/expenses/download',
    // IFAS debug console (SuperAdmin, proxied through API to IFAS)
    ifas: '/ifas',
    // IFAS push calls kept in master.ifas_request_log: list and one by id (SuperAdmin)
    ifasRequestLogs: '/ifas-request-logs',
    // Platform-wide key/value settings in master.global_config (list: any role, write: SuperAdmin)
    globalConfig: '/config',
    // Third-party API clients and their keys (SuperAdmin, master DB)
    apiClients: '/api-clients',
    // Its own path: the backend keeps this route above its `:id` catch-all.
    apiClientsScopes: '/api-clients/scopes',
  },
  apiClientRoutes: {
    byId: (id: string) => `/api-clients/${id}`,
    keys: (id: string) => `/api-clients/${id}/keys`,
    extend: (id: string, keyId: string) => `/api-clients/${id}/keys/${keyId}/extend`,
    rotate: (id: string, keyId: string) => `/api-clients/${id}/keys/${keyId}/rotate`,
    revoke: (id: string, keyId: string) => `/api-clients/${id}/keys/${keyId}/revoke`,
  },
  competitionClubs: (competitionId: string) => `/competitions/${competitionId}/clubs`,
  /**
   * SC-1227 stage and group CRUD. Kept byte-identical to the `competitionStages` block in
   * `packages/api-endpoints/apiEndpoints.ts` — the two maps have already drifted by ~35 lines, so
   * they cannot be kept in step by copy-paste of the whole file, and nothing but an app build
   * catches a key that exists in one and not the other.
   *
   * Every path is keyed on the subdocument `_id`, never on a position in `stages[]` or `groups[]`.
   * `reorder` sits above `byId` because `/stages/reorder` is otherwise matched by the `:stageId`
   * param route. `group`'s DELETE archives rather than removes — see the hook.
   */
  competitionStages: {
    create: (competitionId: string) => `/competitions/${competitionId}/stages`,
    reorder: (competitionId: string) => `/competitions/${competitionId}/stages/reorder`,
    byId: (competitionId: string, stageId: string) => `/competitions/${competitionId}/stages/${stageId}`,
    groups: (competitionId: string, stageId: string) => `/competitions/${competitionId}/stages/${stageId}/groups`,
    group: (competitionId: string, stageId: string, groupId: string) =>
      `/competitions/${competitionId}/stages/${stageId}/groups/${groupId}`,
    groupTeams: (competitionId: string, stageId: string, groupId: string) =>
      `/competitions/${competitionId}/stages/${stageId}/groups/${groupId}/teams`,
    /**
     * Un-archive a group (POST) — the exact inverse of `group`'s DELETE, restoring its `_id`, its
     * name and its teams. It exists because the delete is a soft one: without a way back, "archive"
     * would be a deletion with extra storage rather than a reversible action.
     */
    groupRestore: (competitionId: string, stageId: string, groupId: string) =>
      `/competitions/${competitionId}/stages/${stageId}/groups/${groupId}/restore`,
  },
  ifasLookup: (entityType: string) => `/ifas/lookup/${entityType}`,
  clubExport: (id: string) => `/clubs/${id}/export`,
  seasonConfigs: {
    list: (competitionId: string) => `/competitions/${competitionId}/seasons`,
    create: (competitionId: string) => `/competitions/${competitionId}/seasons`,
    current: (competitionId: string) => `/competitions/${competitionId}/seasons/current`,
    byId: (competitionId: string, seasonId: string) => `/competitions/${competitionId}/seasons/${seasonId}`,
    update: (competitionId: string, seasonId: string) => `/competitions/${competitionId}/seasons/${seasonId}`,
    delete: (competitionId: string, seasonId: string) => `/competitions/${competitionId}/seasons/${seasonId}`,
    setCurrent: (competitionId: string, seasonId: string) =>
      `/competitions/${competitionId}/seasons/${seasonId}/set-current`,
    activate: (competitionId: string, seasonId: string) =>
      `/competitions/${competitionId}/seasons/${seasonId}/activate`,
  },
  matchChangesets: {
    submit: (matchId: string) => `/matches/${matchId}/changeset`,
    byMatch: (matchId: string) => `/matches/${matchId}/changeset`,
    pending: '/matches/changesets/pending',
    approve: (changesetId: string) => `/matches/changesets/${changesetId}/approve`,
    reject: (changesetId: string) => `/matches/changesets/${changesetId}/reject`,
    retract: (changesetId: string) => `/matches/changesets/${changesetId}`,
  },
  // The admin's manual "Pull from IFAS": POST pulls, GET lists the match's pulls (`?page=&limit=`), GET one reads it.
  matchIfasPulls: {
    pull: (matchId: string) => `/matches/${matchId}/ifas-pull`,
    list: (matchId: string) => `/matches/${matchId}/ifas-pulls`,
    byId: (matchId: string, pullId: string) => `/matches/${matchId}/ifas-pulls/${pullId}`,
  },
  invoiceRoutes: {
    byId: (id: string) => `/invoices/${id}`,
    paid: (id: string) => `/invoices/${id}/paid`,
    send: (id: string) => `/invoices/${id}/send`,
    pdf: (id: string) => `/invoices/${id}/pdf`,
  },
  repeatableInvoiceRoutes: {
    byId: (id: string) => `/repeatable-invoices/${id}`,
  },
  expenseRoutes: {
    byId: (id: string) => `/expenses/${id}`,
    // Streams the stored PDF; `?disposition=inline` previews rather than downloads. 404s for a
    // row that holds no document, which is what `needs_document` means — see openExpenseDocument.
    document: (id: string) => `/expenses/${id}/document`,
  },
  // SC-894: the source Important Date, for the admin edit dialog. The list endpoint returns
  // expanded occurrences, so this is the only route yielding the parent with its recurrence.
  event: (id: string) => `/events/${encodeURIComponent(id)}`,
  fileView: (id: string) => `/files/${id}/view`,
  fileViews: (id: string) => `/files/${id}/views`,
  folderGrants: (id: string) => `/folders/${id}/grants`,
  folderGrantClubs: (id: string) => `/folders/${id}/grants/clubs`,
  folderGrantClub: (id: string, clubId: string) => `/folders/${id}/grants/clubs/${clubId}`,
  folderGrantAllClubs: (id: string) => `/folders/${id}/grants/all-clubs`,
  folderGrantDivision: (id: string) => `/folders/${id}/grants/division`,
  folderNotify: (id: string) => `/folders/${id}/notify`,
  // SC-942: PUT to set / DELETE to clear a Tag's polymorphic Club/Player association
  tagAssociation: (id: string) => `/tags/${id}/association`,
};
